/*
 * @Author: Zhouqi
 * @Date: 2025-11-05 10:44:07
 * @LastEditors: Ryan
 * @LastEditTime: 2026-01-16
 */
import dynamic from 'next/dynamic';
import React from 'react';

import VoiceCloningSkeleton from '@/3.0/ai-voice-cloning/_components/voice-cloning-skeleton';
import { Introduction } from '@/components/container';
import DelayedRender from '@/components/DelayRender';
import Footer from '@/components/Footer';
import Layout from '@/components/layout';
import SEOHead from '@/landing/components/SEOHead';
import { createSoftwareAppSchema } from '@/landing/utils/structuredData';

const VoiceClone = dynamic(() => import('../../3.0/ai-voice-cloning/entry'), {
  ssr: false,
  loading: () => (
    <DelayedRender>
      <VoiceCloningSkeleton />
    </DelayedRender>
  ),
});

const SEOSections = dynamic(() => import('../../3.0/ai-voice-cloning/seo'), {
  ssr: true,
});

// SEO 常量
const PAGE_TITLE = 'AI Voice Cloning - Clone Your Voice with AI | FalcoCut';
const META_DESCRIPTION =
  'Clone any voice with AI-powered voice cloning technology. Create natural-sounding voiceovers in multiple languages with FalcoCut AI Voice Cloning.';
const CURRENT_URL = 'https://falcocut.ai/ai-voice-cloning';

// 结构化数据
const structuredData = createSoftwareAppSchema({
  name: 'FalcoCut AI Voice Cloning',
  description: META_DESCRIPTION,
  url: CURRENT_URL,
  ratingValue: '4.9',
  ratingCount: '1890',
  featureList: [
    'Clone any voice with AI',
    'Natural-sounding voiceovers',
    'Multi-language support',
    'Text to speech conversion',
    'Voice customization',
    'High-quality audio output',
  ],
});

const VoiceClonePage: React.FC & {
  getLayout?: (page: React.ReactElement) => React.ReactNode;
  getExtraContent?: () => React.ReactNode;
} = () => {
  return (
    <>
      <SEOHead
        title={PAGE_TITLE}
        description={META_DESCRIPTION}
        url={CURRENT_URL}
        imageAlt="FalcoCut AI Voice Cloning"
        publishedTime="2025-11-05"
        modifiedTime="2026-01-16"
        structuredData={structuredData}
      />

      <VoiceClone />
    </>
  );
};

// 定义 getLayout 为直接返回页面本身，不使用 Layout
VoiceClonePage.getLayout = (page: React.ReactElement) => <Layout>{page}</Layout>;

// 定义 SEO 部分和 Footer 作为额外内容，在 Layout 外渲染
VoiceClonePage.getExtraContent = () => {
  return (
    <Introduction>
      <SEOSections />
      <Footer />
    </Introduction>
  );
};

export const getStaticProps = async () => {
  return {
    props: {},
  };
};

export default VoiceClonePage;
